import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { TokenService } from '../token/token.service';
import { WebTypeConstant } from 'src/app/shared/constants/common-constant';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class LanguageService {
    private languageSubject = new BehaviorSubject<any>(null);
    selectedLanguage$ = this.languageSubject.asObservable();

    constructor(
        private token: TokenService,
        private translate: TranslateService
    ) {
        const savedLang = this.token.getLocalToken(env.TokenKeys.Language) || env.DefaultLanguageCode;
        this.languageSubject.next(savedLang);
        this.translate.use(savedLang);
    }

    setLanguage(language: any) {
        this.languageSubject.next(language);
        this.token.setLocalToken(env.TokenKeys.Language, language);
        this.translate.use(language);
    }

    getLanguage() {
        return this.languageSubject.value ?? env.DefaultLanguageCode;
    }

    getLangPrefix(webType: string): string {
        switch (webType) {
            case WebTypeConstant.ADMIN:
            case WebTypeConstant.ADMINSTAFF:
                return 'admin';
            case WebTypeConstant.MERCHANT:
            case WebTypeConstant.MERCHANTSTAFF:
                return 'merchant';
            case WebTypeConstant.AGENTUNLIMITED:
            case WebTypeConstant.AGENTSTAFFUNLIMITED:
                return 'agent';
            default:
                return ''; // fallback or log warning if needed
        }
    }
}